import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './tools/sentry';
import { PostHogProvider } from 'posthog-js/react';
import { PostHogConfig } from 'posthog-js';
import { SessionProvider } from './context/session/SessionProvider.tsx';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { oAuthConfig } from '@fd/common/auth/config.ts';
import '/node_modules/flag-icons/css/flag-icons.min.css';

const postHogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={postHogOptions}
    >
      <SessionProvider>
        <GoogleOAuthProvider clientId={oAuthConfig.googleOAuthClientId}>
          <App />
        </GoogleOAuthProvider>
      </SessionProvider>
    </PostHogProvider>
  </React.StrictMode>
);
